import React from 'react';
import Navbar from './Navbar';

const ShopPage = () => {
  return (
    <>
    <Navbar />
    <div>
      <h1>Shop Page</h1>
      <p>Browse our products here.</p>
    </div>
    </>
  );
};

export default ShopPage;
